export default __webpack_public_path__ + "static/media/bh.4da02938.svg";